import { FC } from 'react';
import { Column as _Column, ColumnProps } from 'react-virtualized';

export const Column = _Column as unknown as FC<ColumnProps>;
